import React, { Component } from "react";
import FormGroup from "../shared/form/FormGroup";
import { connect } from "react-redux";
import {
  setIsValueChanged
} from "../../actions/policy/policyActions";

const mapDispatchToProps = (dispatch) => {
  return {
    setIsValueChanged: (Value) => dispatch(setIsValueChanged(Value))
  };
};

export class ContactPreferenceSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ContactPreference: [],
    };
    this.PreferenceChanges = this.PreferenceChanges.bind(this);
    this.updatedValue = this.updatedValue.bind(this);
  }
  componentDidMount(){
    let updateContactPrefs=[];
    if(this.props.contactPrefsKeys !== undefined && this.props.contactPrefsKeys !==null )
      {
        if(this.props.contactValue !== null && this.props.contactValue !== undefined){
            this.props.contactValue.forEach((value)=>{
              let updateValue={
              PersonContactPrefId: value.PersonContactPrefId,
              PersonId: value.PersonId,
              ContactPreferenceId: value.ContactPreferenceId,
              ContactPreferenceName: value.ContactPreferenceName,
              CreatedBy: value.CreatedBy,
              LastUpdatedBy: value.LastUpdatedBy,
              SourceSystem: value.SourceSystem,
              SourcePersonId: value.SourcePersonId,
              IsDeleted:false
              };
              updateContactPrefs.push(updateValue);
            });
            this.setState({
              ContactPreference:updateContactPrefs
          },()=>{
            this.updateContactPreferences(this.state.ContactPreference);
          });
        }
      }
  }
  componentDidUpdate(prevProps){
    if(JSON.stringify(prevProps.contactValue)!==JSON.stringify(this.props.contactValue))
    {
      this.updatedValue(this.props.contactValue);
    }
    }

    updatedValue(contactValue){
      if(contactValue!==null)
      {
          this.setState({
              ContactPreference:contactValue,
          });
      }
      else{
        this.setState({
          ContactPreference:[],
      });
      }
      
    }

  PreferenceChanges(event,ContactPreferenceId){
    this.IsContactValueChanged(true);
    this.props.setIsValueChanged(true);
    const contact = this.state.ContactPreference;
    const index = contact.findIndex(m => m.ContactPreferenceId === ContactPreferenceId);
    const masterData = this.props.contactPrefsKeys.filter((val)=>val.ContactPreferenceId === ContactPreferenceId);
    if(index !== -1)
   {
      let existflag = [];
      if(this.props.contactValue !==null && this.props.contactValue !== undefined)
      {
        let originalValue = this.props.contactValue;
            existflag = originalValue.filter(value=>{
            return value.ContactPreferenceId===contact[index].ContactPreferenceId;
          });
      }
      
    if(existflag.length!==0 && contact[index].PersonContactPrefId!==0)
    {
      //Add or delete from existing preference(Yes->No)
      contact[index].IsDeleted = event.target.value==="false"?true:false;
    }else{
      // Delete entry from existing array(No->Yes->No)
      contact.splice(index,1);
    }
    this.setState({
      ContactPreference:contact
    });
   }
   else{
    //New entry(No -> yes)
    let newValue;
    if(this.props.contactValue!==null)
    {
        newValue ={
        PersonContactPrefId: 0,
        PersonId: this.state.ContactPreference[0].PersonId,
        ContactPreferenceId: masterData[0].ContactPreferenceId,
        ContactPreferenceName: masterData[0].ContactPreferenceName,
        CreatedBy: this.props.MemberName,
        LastUpdatedBy: this.props.MemberName,
        SourceSystem: this.state.ContactPreference[0].SourceSystem,
        SourcePersonId: this.state.ContactPreference[0].SourcePersonId,
        IsDeleted:false
        };
    }
    else{
      newValue ={
        PersonContactPrefId: 0,
        PersonId: "",
        ContactPreferenceId: masterData[0].ContactPreferenceId,
        ContactPreferenceName: masterData[0].ContactPreferenceName,
        CreatedBy: this.props.MemberName,
        LastUpdatedBy: this.props.MemberName,
        SourceSystem: "",
        SourcePersonId: "",
        IsDeleted:false
        };
    }
    const newArrayVal = this.state.ContactPreference;
    newArrayVal.push(newValue);
    this.setState({
      ContactPreference:newArrayVal
    });
   }
    this.updateContactPreferences(this.state.ContactPreference);
  }

  updateContactPreferences(contactprefs) {
    this.props.updateContactPreferences(contactprefs);
  }

  IsContactValueChanged(value)
  {
    this.props.IsContactValueChanged(value);
  }
  render() {
      if(this.props.contactPrefsKeys !== undefined && this.props.contactPrefsKeys !==null )
      {
      return this.props.contactPrefsKeys.length >0 && this.props.contactPrefsKeys.map(informMethod => {
      let contactOptionValue = false;
      if(this.props.contactValue !== null && this.props.contactValue !== undefined){
        contactOptionValue = this.props.contactValue.some(val => val.ContactPreferenceId === informMethod.ContactPreferenceId);
      }
      return (
        <FormGroup
          className={"form-group mt-0"}
          type="yesno"
          id={"contact" + informMethod.ContactPreferenceName}
          label={informMethod.ContactPreferenceName}
          key={informMethod.ContactPreferenceName}
          currentValue={contactOptionValue}
          onChange={ (event) =>{
            this.PreferenceChanges(event,informMethod.ContactPreferenceId);
            return event.target.value === "true"
            ? true
            : event.target.value === "false"
            ? false
            : null;
            }
          }
          Zebrafied={this.props.Zebrafied}
          UseSlider={this.props.UseSlider}
        />
      );
    });
  }
  return null;
}
}

export default connect(
  null,
  mapDispatchToProps
)(ContactPreferenceSection);